export default "__VITE_ASSET__7bLQ1RT2__"